import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../services/common/token.service';
import { BaseService } from '../services/common/base.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BehaviorSubject, observable } from 'rxjs';

@Injectable()
export class OnFarmMiService extends BaseService {
    protected http: HttpClient;
    onDatatablessChanged: BehaviorSubject<any>;

    constructor(http: HttpClient, tokenService: TokenService) {
        super(tokenService);
        this.http = http;
        this.onDatatablessChanged = new BehaviorSubject({});
    }
    GetOnFarmMi(farmerId: any) {
        // return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetByFarmerID?FarmerID=${farmerId}`, { headers: this.buildHeaders() });
        return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetByFarmerID?FarmerID=${farmerId}`);
    }

    InsertOnFarmMi(onFramMiModel: any) {
        // return this.http.post(`${environment.apiUrl}OnFormMI/Insert`, onFramMiModel, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}OnFormMI/Insert`, onFramMiModel);
    }
    
    UpdateOnFarmMi(onFramMiModel: any) {
        // return this.http.post(`${environment.apiUrl}OnFormMI/Update`, onFramMiModel, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}OnFormMI/Update`, onFramMiModel);
    }

    DeleteOnFarmMi(onFramMiModel: any) {
        // return this.http.post(`${environment.apiUrl}OnFormMI/Delete`, onFramMiModel, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}OnFormMI/Delete`, onFramMiModel);
    }

    GetWaterQuality() {
        // return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetWaterQuality`, { headers: this.buildHeaders() });
        return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetWaterQuality`);
    }

    GetFarmerPastSubsidyByFarmerId(farmerId) {
        // return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetFarmerPastSubsidyByFarmerId?FarmerId=${farmerId}`, { headers: this.buildHeaders() });
        return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetFarmerPastSubsidyByFarmerId?FarmerId=${farmerId}`);
    }

    GetFarmerPastSubsidyByMultipleFarmerIds(farmerIds) {
        // return this.http.get<any>(`${environment.apiUrl}OnFormMI/GetFarmerPastSubsidyByFarmerId?FarmerId=${farmerId}`, { headers: this.buildHeaders() });
        return this.http.post(`${environment.apiUrl}OnFormMI/GetFarmerPastSubsidyByMultipleFarmerIds`, farmerIds);
    }

    insertOnFarmMIDetails_CR(onFramMiModel: any) {
        return this.http.post(`${environment.apiUrl}ChangeRequest/InsertOnFarmMIDetails_CR`, onFramMiModel);
    }
}